import { render, staticRenderFns } from "./RolesAdd.vue?vue&type=template&id=e1ec3310"
import script from "./RolesAdd.vue?vue&type=script&lang=js"
export * from "./RolesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports